/**
 * Splits `text` around the first case-insensitive occurrence of `needle`.
 * Returns `null` when `needle` is empty or not found, so callers can render
 * the original text unchanged.
 */
export interface MatchSegments {
  before: string;
  match: string;
  after: string;
}

export function highlightMatch(
  text: string,
  needle: string
): MatchSegments | null {
  if (!needle) return null;
  const lowerText = text.toLowerCase();
  const lowerNeedle = needle.toLowerCase();
  const idx = lowerText.indexOf(lowerNeedle);
  if (idx < 0) return null;
  return {
    before: text.slice(0, idx),
    match: text.slice(idx, idx + needle.length),
    after: text.slice(idx + needle.length),
  };
}
